import type { AdminProfile, AdminProfileUpdate } from '@/types/admin-profile';
import api, { API_PREFIX } from './api';

// The key has no user id: PropelAuth logout reloads the page, which clears the query cache.
export const ADMIN_PROFILE_STATE_KEY = 'admin-profile';

export const getAdminProfile = () => api.get<AdminProfile>(`${API_PREFIX}/me/profile`);

export const updateAdminProfile = (payload: AdminProfileUpdate) =>
  api.patch<AdminProfile>(`${API_PREFIX}/me/profile`, payload);
